import { Link, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    // Debug log to help troubleshoot routing issues
    console.log('404 page rendered for path:', location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 dark:from-black dark:via-gray-900 dark:to-gray-800 flex items-center justify-center px-4">
      <div className="max-w-lg w-full text-center">
        {/* Brand Header */}
        <div className="mb-8">
          <Link to="/" className="inline-flex items-center space-x-2 mb-6">
            <img src="/apple-touch-icon.png" alt="EightyThreeLabs" className="w-12 h-12" />
            <span className="text-3xl font-semibold">
              <span className="text-brand-primary">EightyThree</span>
              <span className="text-black dark:text-white">Labs</span>
            </span>
          </Link>
        </div>

        {/* 404 Visual */}
        <div className="mb-8">
          <div className="text-8xl mb-4">🤔</div>
          <h1 className="text-6xl font-bold text-gray-800 dark:text-gray-100 mb-4">404</h1>
          <h2 className="text-2xl font-semibold text-gray-700 dark:text-gray-200 mb-2">
            Page Not Found
          </h2>
          <p className="text-gray-600 dark:text-gray-300 mb-8">
            Oops! The page you're looking for seems to have vanished into thin air. 
            Let's get you back on track with your mathematical journey.
          </p>
        </div>

        {/* Action Buttons */}
        <div className="space-y-4">
          <Link
            to="/"
            className="block bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-8 py-3 rounded-lg font-semibold hover:from-blue-700 hover:to-indigo-700 transition-all shadow-lg"
          >
            🏠 Return to Dashboard
          </Link>
          
          <Link
            to="/signup-with-subscription"
            className="block bg-gradient-to-r from-yellow-500 to-orange-600 text-white px-8 py-3 rounded-lg font-semibold hover:from-yellow-600 hover:to-orange-700 transition-all shadow-lg"
          >
            ✨ Start Your Journey
          </Link>
        </div>

        {/* Helpful Links */}
        <div className="mt-8 pt-6 border-t border-gray-200 dark:border-gray-700">
          <p className="text-sm text-gray-500 dark:text-gray-400 mb-3">Quick links:</p>
          <div className="flex flex-wrap justify-center gap-2 text-sm">
            <Link to="/profile" className="text-blue-600 dark:text-blue-400 hover:underline">Profile</Link>
            <span className="text-gray-400">•</span>
            <Link to="/upgrade" className="text-blue-600 dark:text-blue-400 hover:underline">Upgrade</Link>
            <span className="text-gray-400">•</span>
            <Link to="/login" className="text-blue-600 dark:text-blue-400 hover:underline">Sign In</Link>
          </div>
        </div>

        {/* Fun Math Fact */}
        <div className="mt-8 bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm rounded-xl p-6 shadow-lg border border-white/20 dark:border-gray-700/50">
          <div className="text-lg mb-3">🔢 Fun Facts About 83</div>
          <div className="text-sm text-gray-600 dark:text-gray-300 space-y-2">
            <p>• The sum of three consecutive primes (23 + 29 + 31)</p>
            <p>• The sum of five consecutive primes (11 + 13 + 17 + 19 + 23)</p>
            <p>• The 23rd prime number, following 79 and preceding 89</p>
            <p>• A Sophie Germain prime and a safe prime</p>
            <p>• A Chen prime - special in number theory!</p>
          </div>
        </div>

        {/* Back to Top */}
        <div className="mt-6">
          <p className="text-xs text-gray-400 dark:text-gray-500">
            Lost in the mathematical cosmos? We'll help you find your way.
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;